import classNames from 'classnames';
import React from 'react';
import {
  branch,
  compose,
  renderNothing,
  setPropTypes
} from 'recompose';
import PropTypes from 'prop-types';
import { links } from '../../constants';

const SupportMessage = branch(
  ({ hideSupport }) => hideSupport,
  renderNothing
)(() => (
  <span>
    Please contact <a href={links.thinkCaddie.contact} target='_blank'>Caddie Support</a>
  </span>
));

/**
 * Responsible to parse and render error messages from the server.
 */
const ServerError = ({ className, error, hideSupport, innerRef, ...props }) => (
  <div ref={innerRef} {...{ ...props, className: classNames('alert alert-danger', className) }}>
    {error} <SupportMessage {...{ hideSupport }} />
  </div>
);

export default compose(
  setPropTypes({
    error: PropTypes.string,
    hideSupport: PropTypes.bool
  }),
  branch(({ error }) => !error, renderNothing)
)(ServerError);



// WEBPACK FOOTER //
// ./src/containers/components/server-error.js